// extracted by css-extract-rspack-plugin
export default {"ActionList_Divider":"PullRequestCodeButton-module__ActionList_Divider__XQ4EiLs"};